module.exports = __webpack_public_path__ + "media/מחשב.6b9b2383.mp3";